var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"app"},[(!_vm.$route.meta.public)?[_c('transition',{attrs:{"name":"slide-fade"}},[_c('app-layout')],1)]:[_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view')],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }